document.addEventListener('DOMContentLoaded', function () {
  console.log('[SPOTET] ✅ DOM chargé');
  const path = window.location.pathname;
  console.log('[SPOTET] 📍 Chemin actuel :', path);

  function matchPath(pattern) {
    const langs = ['', '/fr', '/de', '/en', '/it'];
    return langs.some(lang =>
      path === `${lang}${pattern}` || path.startsWith(`${lang}${pattern}/`)
    );
  }

  function getActiveId() {
    if (matchPath('/collections')) return 'nav-plats';
    if (matchPath('/pages')) return 'nav-contact';
    if (matchPath('/account')) return 'nav-compte';
    if (matchPath('/') || /^\/(fr|de|it|en)?\/?$/.test(path)) return 'nav-home';
    return null;
  }

  const id = getActiveId();
  console.log('[SPOTET] 🔎 ID actif attendu :', id);
  if (!id) return;

  let attempts = 0;
  const maxAttempts = 5;
  const interval = setInterval(() => {
    const candidates = document.querySelectorAll(`#${id}`);
    let applied = false;

    candidates.forEach((el) => {
      const visible = el.offsetParent !== null;
      if (visible && !applied) {
        el.classList.add('nav-active');
        console.log('[SPOTET] ✅ .nav-active appliqué à', id, '→', el);
        applied = true;
        clearInterval(interval);
      }
    });

    if (!applied && ++attempts >= maxAttempts) {
      console.warn('[SPOTET] ❌ Élément', id, 'non trouvé ou invisible après', maxAttempts, 'tentatives');
      clearInterval(interval);
    }
  }, 50);
});